/**
 * Form layout rhythm (MUI spacing units).
 * Row gaps must clear outlined InputLabel notches (~10–12px) so fields never collide.
 */
export const FORM_GRID_SPACING = 2.5 as const;

/** Filters / toolbars — still label-safe, slightly denser than default. */
export const FORM_GRID_SPACING_COMPACT = 2 as const;

/** Matches compact outlined control height for row alignment. */
export const FORM_CONTROL_MIN_HEIGHT = 36;

/** Vertical rhythm inside dialog bodies / stacked form groups. */
export const FORM_STACK_GAP = 2 as const;

/** Responsive grid column presets — use with `AppFormField`. */
export const GRID_FULL = { xs: 12 } as const;
export const GRID_HALF = { xs: 12, sm: 6 } as const;
export const GRID_THIRD = { xs: 12, md: 4 } as const;
export const GRID_TWO_THIRDS = { xs: 12, md: 8 } as const;
export const GRID_QUARTER = { xs: 12, sm: 6, md: 3 } as const;
export const GRID_FILTER_2 = { xs: 12, md: 6 } as const;
export const GRID_FILTER_3 = { xs: 12, md: 4 } as const;

/** Pass to AppSelect so FormControl + OutlinedInput match TextField height in chart panels. */
export const chartOptionSelectFormProps = {
  formControlProps: { sx: { width: "100%" } },
} as const;

/**
 * Semantic palette tokens — light mode defaults.
 * Dark mode equivalents live in `theme-dark/base/colors.ts`.
 */
export const SEMANTIC_COLORS = {
  light: {
    primary: "#3D7A76",
    secondary: "#5C6F7A",
    background: "#F4F8F7",
    surface: "#FFFFFF",
    text: "#304153",
    textMuted: "#5C6F7A",
    border: "#C5D0D6",
    divider: "#D8E0E8",
    error: "#B91C1C",
    warning: "#B45309",
    success: "#6B8248",
    info: "#4F8F8B",
  },
  dark: {
    primary: "#83BAB7",
    secondary: "#8B919D",
    background: "#08090C",
    surface: "#0E1014",
    text: "#D8DBE2",
    textMuted: "#8B919D",
    border: "#1C1F28",
    divider: "#1C1F28",
    error: "#F87171",
    warning: "#FBBF24",
    success: "#8DA060",
    info: "#83BAB7",
  },
} as const;
